module.exports = __webpack_public_path__ + "static/polishFlag-e5d3b1143e960bab02c525976b9dfc7f.svg";